import Tabs from "@components/Tabs/Tabs";
import { useByoDataContext } from "@pages/Byo/ByoContext";
import { ByoAnalyticType } from "@models/Byo";

const byoTopChartItems = [
    {
        name: 'Penetration',
        id: ByoAnalyticType.Penetration,
        tooltip: '% of restaurants',
    },
    {
        name: 'Incidence',
        id: ByoAnalyticType.Incidence,
        tooltip: '% of items',
    },
    {
        name: 'Price',
        id: ByoAnalyticType.Price,
        tooltip: 'Median price',
    },
    {
        name: 'Count',
        id: ByoAnalyticType.Count,
        tooltip: 'Average # of items',
    },
];

export function getByoAnalyticTypeName(type: ByoAnalyticType) {
    const item = byoTopChartItems.find(item => item.id === type);
    return item ? item.name : '';
}

const AnalyticsTypeTabs = () => {
    const { activeAnalyticsType, setActiveAnalyticsType } = useByoDataContext();

    return (
        <Tabs
            data={byoTopChartItems}
            handleClick={(id) => setActiveAnalyticsType(id as ByoAnalyticType)}
            activeItemId={activeAnalyticsType}
        />
    );
};

export default AnalyticsTypeTabs;